export var TabsNameEnum;
(function (TabsNameEnum) {
    TabsNameEnum["Home"] = "Home";
    TabsNameEnum["Rewards"] = "Rewards";
    TabsNameEnum["Orders"] = "Orders";
    TabsNameEnum["MyOrders"] = "MyOrders";
    TabsNameEnum["Store"] = "Store";
    TabsNameEnum["Account"] = "Account";
})(TabsNameEnum || (TabsNameEnum = {}));
export var TabsTextEnum;
(function (TabsTextEnum) {
    TabsTextEnum["Home"] = "Home";
    TabsTextEnum["Rewards"] = "Rewards";
    TabsTextEnum["Orders"] = "Orders";
    TabsTextEnum["MyOrders"] = "My Orders";
    TabsTextEnum["Store"] = "Store";
    TabsTextEnum["Account"] = "Account";
})(TabsTextEnum || (TabsTextEnum = {}));
//# sourceMappingURL=TabsNameEnum.js.map